// src/stores/useStreak.ts
import { create } from 'zustand'
import { supabase } from '../services/supabase'
import { useSettings } from './useSettings'

interface StreakStore {
  streak: number
  loading: boolean
  load: () => Promise<void>
  refresh: () => Promise<void>
}

export const useStreak = create<StreakStore>((set, get) => ({
  streak: 0,
  loading: false,

  load: async () => {
    set({ loading: true })
    try {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) return

      const threshold = useSettings.getState().settings.snr_notification_threshold || 75

      const { data, error } = await supabase.rpc('get_snr_streak', {
        p_user_id: session.user.id,
        p_threshold: threshold,
      })

      if (error) throw error
      set({ streak: data || 0 })
    } catch (error) {
      console.error('Error loading streak:', error)
    } finally {
      set({ loading: false })
    }
  },

  refresh: async () => {
    await get().load()
  },
}))
